import type { ModalProps } from '@shopify/app-bridge-react';
import type React from 'react';

import { Modal, TitleBar } from '@shopify/app-bridge-react';

interface IPrimaryAction {
  content: string;
  variant?: 'primary' | 'breadcrumb' | null;
  disabled?: boolean;
  loading?: boolean;
  onAction: () => void;
}

interface ISecondaryAction {
  content: string;
  onAction: () => void;
  loading?: boolean;
}

export interface IGModalBridgeProps {
  id?: string;
  open?: boolean;
  variant?: ModalProps['variant'];
  title?: string;
  isHideScrollbar?: boolean;
  primaryAction?: IPrimaryAction;
  secondaryAction?: ISecondaryAction;
  children?: React.ReactNode;
  onHide?: () => void;
}

export const GModalBridge = ({
  id,
  open,
  variant = 'base',
  title,
  primaryAction,
  secondaryAction,
  children,
  onHide,
}: IGModalBridgeProps) => {
  return (
    <Modal id={id} variant={variant} open={!!open} onHide={() => onHide?.()}>
      {children}
      <TitleBar title={title}>
        {primaryAction && (
          <button
            variant={primaryAction.variant}
            disabled={primaryAction.disabled}
            onClick={primaryAction.onAction}
            {...(primaryAction.loading ? { loading: 'loading' } : {})}
          >
            {primaryAction.content}
          </button>
        )}
        {secondaryAction && (
          <button
            onClick={secondaryAction.onAction}
            {...(secondaryAction.loading ? { loading: 'loading' } : {})}
          >
            {secondaryAction.content}
          </button>
        )}
      </TitleBar>
    </Modal>
  );
};
